import React from 'react';

export const GoldenEggSphereSM = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={!!props.width ? props.width : 50}
      height={!!props.height ? props.height : 53}
      viewBox="0 0 50 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#a)">
        <path
          d="M33.096 26.5c0 5.377-3.644 9.734-8.14 9.734s-8.141-4.358-8.141-9.733c0-5.376 4.157-9.733 8.14-9.733 4.497 0 8.141 4.357 8.141 9.733Z"
          fill="url(#b)"
        />
        <path
          d="M33.096 26.5c0 5.377-3.644 9.734-8.14 9.734s-8.141-4.358-8.141-9.733c0-5.376 4.157-9.733 8.14-9.733 4.497 0 8.141 4.357 8.141 9.733Z"
          fill="url(#c)"
          style={{
            mixBlendMode: 'overlay',
          }}
        />
        <path
          d="M33.096 26.5c0 5.377-3.644 9.734-8.14 9.734s-8.141-4.358-8.141-9.733c0-5.376 4.157-9.733 8.14-9.733 4.497 0 8.141 4.357 8.141 9.733Z"
          fill="#D9A625"
          style={{
            mixBlendMode: 'color',
          }}
        />
      </g>
      <g filter="url(#d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.956 35.721c4.13 0 7.627-4.038 7.627-9.22s-3.497-9.22-7.627-9.22c-1.807 0-3.711.994-5.178 2.675a10.01 10.01 0 0 0-2.45 6.545c0 5.182 3.497 9.22 7.628 9.22Zm0 .513c4.496 0 8.14-4.358 8.14-9.733 0-5.376-3.644-9.733-8.14-9.733-3.983 0-8.141 4.357-8.141 9.733 0 5.375 3.645 9.733 8.14 9.733Z"
          fill="#fff"
          fillOpacity={0.7}
        />
      </g>
      <path
        d="M33.096 26.5c0 5.377-3.644 9.734-8.14 9.734s-8.141-4.358-8.141-9.733c0-5.376 4.157-9.733 8.14-9.733 4.497 0 8.141 4.357 8.141 9.733Z"
        fill="url(#e)"
      />
      <path
        d="M33.096 26.5c0 5.377-3.644 9.734-8.14 9.734s-8.141-4.358-8.141-9.733c0-5.376 4.157-9.733 8.14-9.733 4.497 0 8.141 4.357 8.141 9.733Z"
        fill="url(#f)"
        style={{
          mixBlendMode: 'overlay',
        }}
      />
      <path
        d="M33.096 26.5c0 5.377-3.644 9.734-8.14 9.734s-8.141-4.358-8.141-9.733c0-5.376 4.157-9.733 8.14-9.733 4.497 0 8.141 4.357 8.141 9.733Z"
        fill="#D9A625"
        style={{
          mixBlendMode: 'color',
        }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.956 35.721c4.13 0 7.627-4.038 7.627-9.22s-3.497-9.22-7.627-9.22c-1.807 0-3.711.994-5.178 2.675a10.01 10.01 0 0 0-2.45 6.545c0 5.182 3.497 9.22 7.628 9.22Zm0 .513c4.496 0 8.14-4.358 8.14-9.733 0-5.376-3.644-9.733-8.14-9.733-3.983 0-8.141 4.357-8.141 9.733 0 5.375 3.645 9.733 8.14 9.733Z"
        fill="#fff"
        fillOpacity={0.7}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.141 29.12c1.476.706 3.532 1.15 5.815 1.15 2.282 0 4.338-.444 5.814-1.15 1.493-.714 2.318-1.655 2.318-2.62h.462c0 1.245-1.047 2.303-2.58 3.037-1.552.742-3.678 1.194-6.014 1.194-2.337 0-4.463-.453-6.014-1.194-1.534-.734-2.581-1.792-2.581-3.037h.462c0 .965.825 1.906 2.318 2.62ZM24.956 22.731c-.279 0-.554.007-.826.02a.23.23 0 1 1-.022-.462 17.916 17.916 0 0 1 1.695 0 .23.23 0 0 1-.022.462c-.271-.013-.547-.02-.825-.02Zm-2.113-.104a.231.231 0 0 1-.197.261c-.579.08-1.13.19-1.646.326a.231.231 0 0 1-.117-.447c.535-.14 1.104-.253 1.699-.336a.23.23 0 0 1 .26.197Zm4.226 0a.23.23 0 0 1 .26-.196c.596.082 1.165.196 1.7.336a.23.23 0 1 1-.117.447 14.235 14.235 0 0 0-1.646-.326.231.231 0 0 1-.197-.26Zm-7.308.735a.231.231 0 0 1-.127.301 7.204 7.204 0 0 0-1.567.852.23.23 0 1 1-.274-.372 7.663 7.663 0 0 1 1.667-.908.23.23 0 0 1 .301.127Zm10.445.022a.23.23 0 0 1 .302-.125 7.694 7.694 0 0 1 1.552.842.23.23 0 1 1-.27.375 7.238 7.238 0 0 0-1.458-.79.231.231 0 0 1-.126-.302Z"
        fill="#202020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.102 33.497c.596-1.78.968-4.254.968-6.997 0-2.744-.372-5.218-.968-6.998-.298-.892-.648-1.596-1.026-2.073-.379-.48-.76-.698-1.12-.698v-.462c.562 0 1.061.34 1.483.873.423.535.794 1.295 1.1 2.213.616 1.84.993 4.365.993 7.145 0 2.779-.377 5.305-.992 7.144-.307.918-.678 1.678-1.101 2.213-.422.532-.921.873-1.484.873v-.461c.362 0 .742-.219 1.122-.698.377-.478.727-1.182 1.025-2.074ZM21.84 26.5c0 .335.006.666.017.992a.231.231 0 0 1-.461.016 30.393 30.393 0 0 1 0-2.016.231.231 0 0 1 .461.016c-.01.326-.016.657-.016.992Zm-.12 2.57a.23.23 0 0 1 .253.207c.067.696.16 1.36.274 1.981a.23.23 0 0 1-.454.084 24.283 24.283 0 0 1-.28-2.02.23.23 0 0 1 .207-.252Zm0-5.14a.23.23 0 0 1-.207-.253c.069-.707.163-1.383.28-2.019a.23.23 0 1 1 .454.084 23.76 23.76 0 0 0-.274 1.98.23.23 0 0 1-.253.208Zm.62 8.814a.23.23 0 0 1 .285.16c.21.735.452 1.373.72 1.89a.23.23 0 1 1-.41.212 10.745 10.745 0 0 1-.754-1.976.231.231 0 0 1 .16-.286Zm.018-12.556a.23.23 0 0 1-.157-.285 10.8 10.8 0 0 1 .698-1.84.231.231 0 0 1 .413.207c-.247.49-.472 1.082-.668 1.76a.23.23 0 0 1-.286.158Z"
        fill="#202020"
      />
      <defs>
        <linearGradient
          id="b"
          x1={15.817}
          y1={32.653}
          x2={43.797}
          y2={22.398}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset={0.172} stopColor="#9EA1A1" />
          <stop offset={0.457} stopColor="#848B8A" />
          <stop offset={0.554} stopColor="#576265" />
          <stop offset={0.823} stopColor="#576265" />
          <stop offset={0.925} stopColor="#757A7B" />
          <stop offset={1} stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={23.314}
          y1={26.501}
          x2={18.914}
          y2={16.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={15.817}
          y1={32.653}
          x2={43.797}
          y2={22.398}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset={0.172} stopColor="#9EA1A1" />
          <stop offset={0.457} stopColor="#848B8A" />
          <stop offset={0.554} stopColor="#576265" />
          <stop offset={0.823} stopColor="#576265" />
          <stop offset={0.925} stopColor="#757A7B" />
          <stop offset={1} stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={23.314}
          y1={26.501}
          x2={18.914}
          y2={16.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <filter
          id="a"
          x={0.815}
          y={0.768}
          width={48.281}
          height={51.467}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={8} result="effect1_foregroundBlur_1122_52842" />
        </filter>
        <filter
          id="d"
          x={0.815}
          y={0.768}
          width={48.281}
          height={51.467}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={8} result="effect1_foregroundBlur_1122_52842" />
        </filter>
      </defs>
    </svg>
  );
};
